import React from "react";
import { Link } from "react-router-dom";

const FeesPaymentHome = () => {
  return (
    <div className="container text-black bg-success rounded p-5 mt-5 mb-5">
      <div className="text-center">
        <div className="col-md-8 m-auto desc_section">
          <h3 className="mb-5 text-white">Select Class for Fee Payment</h3>
          <div className="d-grid gap-3 d-md-flex justify-content-center flex-wrap">
            {[
              "PRE-NURSERY",
              "NURSERY",
              "LKG",
              "UKG",
              1,
              2,
              3,
              4,
              5,
              6,
              7,
              8,
              9,
              10,
            ].map((class_number) => (
              <Link
                key={class_number}
                to={`/erp/fees/payment/class/${class_number}`}
                className="text-decoration-none"
              >
                <button
                  type="button"
                  className="btn btn-outline-dark py-3 px-4 shadow-sm hover-shadow-lg fw-bold"
                >
                  {typeof class_number === "number"
                    ? `Class ${class_number}`
                    : class_number}
                </button>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeesPaymentHome;
